import { Colors } from "@fuse/styles/color"

export const containerStyle: React.CSSProperties = {}

export const logoText: React.CSSProperties = {
  fontWeight: "700",
  textAlign: "start",
  color: Colors.white,
  fontFamily: "DM Sans",
}

export const headingStyle: React.CSSProperties = {
  fontWeight: "700",
  textAlign: "start",
  color: "#1E0E62",
  fontFamily: "DM Sans",
}
export const textContainer: React.CSSProperties = {
  marginTop: 40,
  marginBottom: 40,
}

export const subTitle: React.CSSProperties = {
  fontSize: 18,
  color: "rgba(21, 20, 57, 0.40)",
  fontWeight: "500",
  fontFamily: "DM Sans",
  textAlign: "start",
}

export const solidBtn: React.CSSProperties = {
  width: 206,
  height: 60,
}
export const greyColor: React.CSSProperties = {
  color: "rgba(21, 20, 57, 0.40)",
  fontWeight: "500",
  fontFamily: "DM Sans",
}
